// Names for what a piece becomes when abilities stack. The log and the
// inspector say them. A combination with no name here is described as its
// parts: "pawn with knight moves". Add names here, not in the engine.
//
// The three fairy chess names are standard and stay. The rest are open.

import type { Ability } from '../engine/types';

export type ComboName = {
  /** Every ability the piece must have. Order does not matter. */
  abilities: readonly Ability[];
  name: string;
};

/** Checked in order. The first match wins, so put the bigger sets first. */
export const COMBO_NAMES: readonly ComboName[] = [
  { abilities: ['knight', 'bishop', 'rook'], name: 'Amazon' },
  { abilities: ['knight', 'rook'], name: 'Chancellor' },
  { abilities: ['knight', 'bishop'], name: 'Archbishop' },
];
